(function () {
"use strict";
var W = window;
if (W.ParadeWindows) return;
W.ParadeWindows = { version: 1 };
var reduce = false;
try { reduce = matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
var CSS = [
".pw .pw-win.is-max{translate:none !important}",
".pw .pw-win.pwa-glide{transition:opacity .4s ease,transform .55s cubic-bezier(.16,.84,.24,1),",
"top .5s cubic-bezier(.2,.8,.2,1),left .5s cubic-bezier(.2,.8,.2,1),max-height .35s ease !important}",
".pw .pw-win{will-change:translate}",
".pwa-edge{position:absolute;inset:0;pointer-events:none;z-index:56;overflow:hidden}",
".pwa-tab{position:absolute;display:flex;align-items:center;gap:8px;max-width:min(46vw,220px);",
"padding:10px 14px;border:0;margin:0;cursor:pointer;pointer-events:auto;",
"background:var(--pw-paper,#e6dec8);color:var(--pw-ink,#14130f);",
"font-family:var(--pw-head,inherit);font-size:13px;line-height:1.1;letter-spacing:.01em;",
"box-shadow:0 10px 28px rgba(20,19,15,.28),0 1px 0 rgba(255,255,255,.5) inset;",
"opacity:0;transition:opacity .3s ease,transform .45s cubic-bezier(.16,.84,.24,1),top .35s ease;",
"-webkit-tap-highlight-color:transparent}",
".pwa-tab[data-side=left]{left:0;border-radius:0 999px 999px 0;padding-left:10px;",
"box-shadow:inset 3px 0 0 var(--pw-red,#7c1512),0 10px 28px rgba(20,19,15,.28);transform:translateX(-110%)}",
".pwa-tab[data-side=right]{right:0;border-radius:999px 0 0 999px;padding-right:10px;flex-direction:row-reverse;",
"box-shadow:inset -3px 0 0 var(--pw-red,#7c1512),0 10px 28px rgba(20,19,15,.28);transform:translateX(110%)}",
".pwa-tab.is-on{opacity:1;transform:translateX(0)}",
".pwa-tab:hover{background:#efe8d6}",
".pwa-tab:focus-visible{outline:2px solid var(--pw-red,#7c1512);outline-offset:2px}",
".pwa-tab span{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}",
".pwa-tab svg{flex:none;width:14px;height:14px}",
".pwa-tab.is-on svg{animation:pwa-nudge 1.6s ease-in-out 2}",
".pwa-tab[data-side=right].is-on svg{animation-name:pwa-nudge-r}",
"@keyframes pwa-nudge{0%,100%{transform:translateX(0)}50%{transform:translateX(-4px)}}",
"@keyframes pwa-nudge-r{0%,100%{transform:translateX(0)}50%{transform:translateX(4px)}}",
"@media (max-width:749px){.pwa-tab{font-size:12px;padding-top:12px;padding-bottom:12px}}",
"@media (prefers-reduced-motion:reduce){.pwa-tab,.pwa-tab svg{animation:none !important;transition:opacity .2s !important}}"
].join("");
function addStyle() {
if (document.querySelector("style[data-parade-windows]")) return;
var s = document.createElement("style");
s.setAttribute("data-parade-windows", "1");
s.textContent = CSS;
(document.head || document.documentElement).appendChild(s);
}
var ARROW = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M9 2 4 7l5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
function now() { return (W.performance && performance.now) ? performance.now() : Date.now(); }
function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
function headerBottom() {
var h = document.querySelector("sticky-header, .shopify-section-header-sticky, .section-header");
if (!h) return 0;
var cs = getComputedStyle(h);
var p = h.parentElement ? getComputedStyle(h.parentElement).position : "";
if (!/sticky|fixed/.test(cs.position + p)) return 0;
var r = h.getBoundingClientRect();
return r.bottom > 0 && r.height < W.innerHeight * 0.4 ? r.bottom : 0;
}
function screenH() { return (W.visualViewport && W.visualViewport.height) || W.innerHeight; }
function screenW() { return (W.visualViewport && W.visualViewport.width) || W.innerWidth; }
function World(root) {
var scene = root.querySelector(".pw__scene");
var viewport = root.querySelector(".pw__viewport");
var layer = root.querySelector(".pw__windows");
if (!scene || !viewport || !layer) return;
var x = readX();
var edge = document.createElement("div");
edge.className = "pwa-edge";
root.appendChild(edge);
var tabs = {};
var gliding = 0;
function readX() {
var m = /translate3d\(\s*(-?[\d.eE+-]+)px/.exec(scene.style.transform || "");
return m ? parseFloat(m[1]) : 0;
}
function wins() { return Array.prototype.slice.call(layer.querySelectorAll(".pw-win")); }
function pinned(win) {
if (win.hidden || win.classList.contains("is-max")) return false;
return getComputedStyle(win).position === "absolute";
}
function shiftOf(win) { return win._pwaAx == null ? 0 : x - win._pwaAx; }
function applyShift(win) {
if (win._pwaAx == null) return;
var t = shiftOf(win);
win.style.translate = Math.abs(t) < 0.01 ? "" : t + "px 0";
}
function bake(win) {
if (win._pwaAx == null) { win._pwaAx = x; return; }
var t = shiftOf(win);
win.classList.remove("pwa-glide");
if (t) {
win.style.left = (win.offsetLeft + t) + "px";
win.style.top = win.offsetTop + "px";
}
win._pwaAx = x;
win.style.translate = "";
}
function onWorldMove() {
var nx = readX();
if (nx === x) return;
x = nx;
wins().forEach(function (w) { if (!w.hidden) applyShift(w); });
queueTabs();
}
new MutationObserver(onWorldMove).observe(scene, { attributes: true, attributeFilter: ["style"] });
root.addEventListener("pointerdown", function (e) {
var bar = e.target.closest && e.target.closest(".pw-win__bar");
if (!bar || e.target.closest("button")) return;
var win = bar.closest(".pw-win");
if (win && pinned(win)) { bake(win); win._pwaUser = 1; }
}, true);
var wasHidden = new WeakMap();
wins().forEach(function (w) { wasHidden.set(w, w.hidden); });
new MutationObserver(function (list) {
list.forEach(function (m) {
var w = m.target;
if (!w.classList || !w.classList.contains("pw-win")) return;
var before = wasHidden.get(w);
wasHidden.set(w, w.hidden);
if (before && !w.hidden) opened(w);
if (!before && w.hidden) closed(w);
});
queueTabs();
}).observe(layer, { attributes: true, subtree: true, attributeFilter: ["hidden", "class"] });
function opened(w) {
w._pwaAx = x;
w._pwaUser = w.dataset.placed ? 1 : 0;
w._pwaH = 0;
w._pwaOpenedAt = now();
w.style.translate = "";
requestAnimationFrame(function () {
requestAnimationFrame(function () { fit(w, true); });
});
setTimeout(function () { fit(w, true); }, 160);
setTimeout(function () { fit(w, true); }, 520);
}
function closed(w) {
w._pwaAx = null;
w.style.translate = "";
w.classList.remove("pwa-glide");
}
function glideClass(w) {
if (reduce) return;
w.classList.add("pwa-glide");
clearTimeout(w._pwaGt);
w._pwaGt = setTimeout(function () { w.classList.remove("pwa-glide"); }, 560);
}
function fit(w, sideways) {
if (!pinned(w) || w._pwaDragging) return;
var L = layer.getBoundingClientRect();
var narrow = W.innerWidth < 750;
var M = narrow ? 8 : 12;
var top0 = Math.max(L.top, headerBottom(), 0) + M;
var bot0 = Math.min(L.bottom, screenH()) - M;
var room = bot0 - top0;
if (room < 160) return;
var h = w.offsetHeight;
if (h > room + 1) {
w.style.maxHeight = Math.floor(room) + "px";
h = Math.min(h, Math.floor(room));
}
var t = shiftOf(w);
var curTop = L.top + w.offsetTop;
var newTop = clamp(curTop, top0, bot0 - h);
var curLeft = L.left + w.offsetLeft + t;
var newLeft = curLeft;
if (sideways) {
var l0 = Math.max(L.left, 0) + M;
var r0 = Math.min(L.right, screenW()) - M;
var ww = w.offsetWidth;
newLeft = ww > r0 - l0 ? l0 + (r0 - l0 - ww) / 2 : clamp(curLeft, l0, r0 - ww);
}
if (Math.abs(newTop - curTop) < 0.5 && Math.abs(newLeft - curLeft) < 0.5) return;
glideClass(w);
w.style.top = (newTop - L.top) + "px";
if (newLeft !== curLeft) w.style.left = (newLeft - L.left - t) + "px";
queueTabs();
}
if (W.ResizeObserver) {
var ro = new ResizeObserver(function (entries) {
entries.forEach(function (en) {
var w = en.target;
if (w.hidden) return;
var h = w.offsetHeight, grew = h > (w._pwaH || 0) + 2;
w._pwaH = h;
var fresh = !w._pwaUser && now() - (w._pwaOpenedAt || 0) < 1800;
/* Oct 30 2026: a window that only gets its full width once it has loaded (the Loops Player, now fetched on demand) is also moved fully on screen */
var wd = w.offsetWidth, wider = wd > (w._pwaW || 0) + 2;
w._pwaW = wd;
if (fresh || !w._pwaUser || grew || wider) fit(w, fresh || (wider && !w._pwaUser));
});
});
wins().forEach(function (w) { ro.observe(w); });
}
W.addEventListener("pointerup", function () {
wins().forEach(function (w) { w._pwaDragging = 0; });
queueTabs();
});
root.addEventListener("pointerdown", function (e) {
var bar = e.target.closest && e.target.closest(".pw-win__bar");
if (bar && !e.target.closest("button")) bar.closest(".pw-win")._pwaDragging = 1;
});
W.addEventListener("resize", function () {
requestAnimationFrame(function () {
x = readX();
wins().forEach(function (w) {
if (w.hidden) return;
applyShift(w);
if (!w._pwaUser) fit(w, false);
});
queueTabs();
});
});
function glideBy(dx) {
cancelAnimationFrame(gliding);
var dur = reduce ? 0 : Math.min(900, 380 + Math.abs(dx) * 0.35);
var start = now(), done = 0;
function step() {
var p = dur ? Math.min(1, (now() - start) / dur) : 1;
var e = 1 - Math.pow(1 - p, 3);
var want = dx * e;
var amt = want - done;
done = want;
if (amt) {
viewport.dispatchEvent(new WheelEvent("wheel", {
deltaX: -amt, deltaY: 0, deltaMode: 0, bubbles: true, cancelable: true
}));
}
if (p < 1) gliding = requestAnimationFrame(step);
}
step();
}
function bringHome(w) {
var L = layer.getBoundingClientRect();
var r = w.getBoundingClientRect();
var l0 = Math.max(L.left, 0), r0 = Math.min(L.right, screenW());
var dx = (l0 + r0) / 2 - (r.left + r.width / 2);
if (r.width > r0 - l0) dx = (l0 + 12) - r.left;
glideBy(dx);
try { w.dispatchEvent(new PointerEvent("pointerdown", { bubbles: false })); } catch (e) {}
if (W.ParadeRooms && W.ParadeRooms.fx && !reduce) {
setTimeout(function () {
var b = w.querySelector(".pw-win__title") || w;
W.ParadeRooms.fx.burstEl(b, 10, 3);
}, Math.min(900, 380 + Math.abs(dx) * 0.35));
}
}
function titleOf(w) {
if (w.dataset && w.dataset.title) return w.dataset.title;
var t = w.querySelector(".pw-win__title");
var s = (t && t.textContent || "").replace(/\s+/g, " ").trim();
return s || (w.dataset.window || "Window");
}
function tabFor(w) {
var id = w.dataset.window;
if (tabs[id]) return tabs[id];
var b = document.createElement("button");
b.type = "button";
b.className = "pwa-tab";
b.innerHTML = ARROW + "<span></span>";
b.addEventListener("click", function (e) {
e.stopPropagation();
bringHome(w);
});
b.addEventListener("pointerdown", function (e) { e.stopPropagation(); });
edge.appendChild(b);
tabs[id] = b;
return b;
}
/* Oct 30 2026: the newspaper and the calendar get the same edge tab as the other windows when they slide off screen */
function extras() {
var out = [], c = document.querySelector('#parade-calendar.on:not(.pcal--full) .pcal__stage'), p = document.querySelector('.pr.pr--open:not(.pr--full) .pr-stage');
if (c) { c._pwaExtra = 1; c.dataset.window = 'pcal-sheet'; c.dataset.title = 'Calendar'; out.push(c); }
if (p) { p._pwaExtra = 1; p.dataset.window = 'riots-paper'; p.dataset.title = 'The public riots'; out.push(p); }
return out;
}
var tabRaf = 0;
W.ParadeWindows.repaint = function () { queueTabs(); };
function queueTabs() {
if (tabRaf) return;
tabRaf = requestAnimationFrame(function () { tabRaf = 0; paintTabs(); });
}
function paintTabs() {
var R = root.getBoundingClientRect();
var l0 = Math.max(R.left, 0), r0 = Math.min(R.right, screenW());
var stack = { left: [], right: [] };
var live = {};
wins().concat(extras()).forEach(function (w) {
if (!w._pwaExtra && (!pinned(w) || w._pwaAx == null)) return;
var r = w.getBoundingClientRect();
var seen = Math.max(0, Math.min(r.right, r0) - Math.max(r.left, l0));
if (seen >= Math.min(r.width, r0 - l0) * 0.22) return;
var side = (r.left + r.width / 2) < (l0 + r0) / 2 ? "left" : "right";
live[w.dataset.window] = 1;
stack[side].push({ w: w, y: r.top - R.top + Math.min(r.height / 2, 56) });
});
["left", "right"].forEach(function (side) {
var list = stack[side].sort(function (a, b) { return a.y - b.y; });
var minGap = 48, floor = 70, ceil = R.height - 70;
var lastY = -Infinity;
list.forEach(function (it) {
var y = clamp(it.y, floor, ceil);
if (y < lastY + minGap) y = lastY + minGap;
lastY = y;
var b = tabFor(it.w);
b.dataset.side = side;
b.querySelector("span").textContent = titleOf(it.w);
b.setAttribute("aria-label", "Back to " + titleOf(it.w));
b.style.top = (y - 20) + "px";
if (!b.classList.contains("is-on")) {
requestAnimationFrame(function () { b.classList.add("is-on"); });
}
});
});
Object.keys(tabs).forEach(function (id) {
if (!live[id]) tabs[id].classList.remove("is-on");
});
}
root.addEventListener("click", function (e) {
var obj = e.target.closest && e.target.closest(".pw__object");
if (!obj || obj.dataset.opens === "link") return;
var w = layer.querySelector('.pw-win[data-window="' + obj.dataset.opens + '"]');
if (!w || w.hidden) return;
setTimeout(function () {
if (!pinned(w)) return;
var r = w.getBoundingClientRect();
var R = root.getBoundingClientRect();
var seen = Math.max(0, Math.min(r.right, R.right, screenW()) - Math.max(r.left, R.left, 0));
if (seen < r.width * 0.6) bringHome(w);
}, 0);
}, true);
if (W.visualViewport) W.visualViewport.addEventListener("resize", queueTabs);
W.addEventListener("scroll", queueTabs, { passive: true });
wins().forEach(function (w) { if (!w.hidden) { w._pwaAx = x; } });
queueTabs();
}
function start() {
addStyle();
var roots = document.querySelectorAll(".pw");
for (var i = 0; i < roots.length; i++) {
if (roots[i]._pwaWorld) continue;
roots[i]._pwaWorld = 1;
try { World(roots[i]); } catch (err) { if (W.console) console.error("[parade windows]", err); }
}
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();
document.addEventListener("shopify:section:load", start);
})();
